<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action
      list-type="picture-card"
      :show-file-list="false"
      :http-request="uploadHttp"
      :before-upload="beforeUpload"
    >
      <template v-if="url">
        <video v-if="category === 'video'" :src="url" controls class="avatar">{{$t('components_uploader_aliyun_single_39')}}</video>
        <img v-else :src="url" class="avatar" />
      </template>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>
<script>
import i18n from '../../locales/index'


import uploadMixin from './mixin'

export default {
  mixins: [ uploadMixin ],
  props: {
    category: String,
    limit: {
      type: Number,
      default: 10
    },
    url: {
      type: String,
    }
  },
}
</script>

<style lang="less" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
